import React from 'react';
import { Link } from 'gatsby';
import sal from 'sal.js';

import Layout from '~/layouts/header-footer';

import SEO from '~/components/seo';

class MePage extends React.Component {
  componentDidMount() {
    sal({
      threshold: 0.1,
    });
  }

  render = () => pug`
    Layout(page={ to: '/me', title: 'Me' })
      SEO(title="Me", description="You want to know about me, don’t you?")
      .me
        .centered-container
          h1.large-title(data-sal="text-animation") Hey!
          .big-body
            p You want to know about me, don’t you?
            p I started coding at age 8.
            p Picture this:
              br
              | It’s 1999. Windows 98 in the house. Floppy disks. The Millennium bug approaching. And a phone line always busy to surf at 24.4&nbsp;Kbps.
            p Arguably, I’m one of the first digital natives in this world.
            p And no. I wasn’t born anywhere near Silicon Valley, I’m from a small countryside town in Italy where even today high&#8209;speed internet is a far mirage.
            p Fast forward: at 16y/o I started freelancing while studying IT.
              br
              | In the meantime, I also began picking up one thing or two about design, user experience, and how to craft products from zero to hero.
            p During my career, I helped multiple startups from all around the world as a digital advisor, filling roles such as Product Owner, UX/UI Designer, and Software Developer.
            p
              Link(to="/now") Now
              |adays, beside being a Product Designer at&nbsp;
              a(style={ color: '#ff6900' }, href="https://zalando.com", target="_blank", rel="noopener") Zalando
              |, I spend most of my spare time building stuff, learning new things, traveling, and creative coding art.
            p Random fun facts:
            ul
              li I’m on a mission to reinvent myself every 2 years.
              li I’m half Italian, and half Dominican (with German roots)
                sup
                  a#ref1(href="#fn1") 1
                | .
              li I’m a huge electronic
                sup.yellow
                  a#ref2(href="#fn2") 2
                | and weird music nerd.
          .footnotes
            hr
            ul
              li
                sup#fn1
                  a(href="#ref1") 1
                small My mother is from Domincan Republic, her grandfathers from Germany. I definitely have to take a DNA test.
              li
                sup.yellow#fn2
                  a(href="#ref2") 2
                small I love exploring every subgenre and/or digital sound...anyhow, do genres still exist?
  `;
}

export default MePage;
